// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"54d9898f","845":"93a2260e"}[chunkId] + ".chunk.js";
};